import React, { useEffect, useRef, useState } from 'react';
import weightLossImage from '../assets/Weightloss-img6.jpg';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import observer from '../utils/observer';

const MoreInfo = () => {
  const [spin, setSpin] = useState(true);
  const containerRefValue = useRef(null);
  const imageRefValue = useRef(null);
  const [isMoreText, setIsMoreText] = useState(false);

  setTimeout(() => {
    setSpin(false);
  }, 2000);

  useEffect(() => {
    observer(containerRefValue, 'section-hidden');
    observer(imageRefValue, 'lazy-load-image');
  }, [containerRefValue, imageRefValue]);

  const showOrHideText = () => {
    setIsMoreText(!isMoreText);
  };

  return (
    <div className="more-info-container section-hidden" ref={containerRefValue}>
      <div className="more-info-image-container">
        <img
          src={weightLossImage}
          alt="natural weight loss"
          className="more-info-image lazy-load-image"
          ref={imageRefValue}
        />
      </div>
      <div className="more-info-text-container">
        <div className="more-info-text-top">
          Expert Guidance for Every Step of Your Healthy Lifestyle
          Transformation
        </div>
        <div className="more-info-text-bottom">
          <div
            className="more-info-text-bottom-text-container"
            style={isMoreText ? { height: '100%', overflow: 'visible' } : {}}
          >
            <div className="more-info-text-bottom-text">
              The journey to a healthier lifestyle is a profound decision. It
              should be your most important decision. At Fitness Space, we're
              here to guide you with expert advice and personalized solutions
              every step of the way. Our team of experienced weight loss coaches
              collaborates with you, offering insights into effective strategies
              like intermittent fasting, guiding you through a tailored portion
              control plan, curating nutrient-dense meal options, and designing
              home workouts to fit your fitness level.
            </div>
            <div className="more-info-text-bottom-text">
              Beyond personalized guidance, our weight loss community provides a
              support network where you connect with like-minded individuals,
              share successes, and draw inspiration. It's a space designed to
              motivate and uplift, making your journey a shared experience. Our
              gamified app injects an element of fun, transforming your pursuit
              of wellness into an engaging adventure. With dynamic features like
              real-time progress tracking and personalized challenges, you'll
              find joy in reaching your goals.
            </div>
            <div className="more-info-text-bottom-text">
              At Fitness Space, we believe that achieving a healthier lifestyle
              involves more than just exercise and nutrition; it's a holistic
              approach. Join us on this transformative journey, where expert
              guidance meets community support, and together, we'll make every
              step count towards your healthier, happier self.
            </div>
          </div>
          <div className="read-more-button" onClick={showOrHideText}>
            <div className="read-more-button-text">
              Read {isMoreText ? 'Less' : 'More'}
            </div>
            <FontAwesomeIcon icon={faArrowRight} spin={spin} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreInfo;
